import { defineAction } from '~/prix'
import { z } from 'zod'
import materialDeliveryDocumentDeleteAction from './materialDeliveryDocumentDelete.action.json' with { type: 'json' }
import { materialDeliveryDocumentObject } from '../materialDeliveryDocumentObject'

const materialDeliveryDocumentDeleteDefinition = defineAction({
  ...materialDeliveryDocumentDeleteAction,
  input: materialDeliveryDocumentObject.pick({ id: true }),
  output: z.object({}),
})

export default materialDeliveryDocumentDeleteDefinition
